import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { AuthenticationService } from '../../core/authentication/auth.service';
import { ClientService } from '../../services/client.service';

@Component({
  selector: 'nli-toolbar',
  templateUrl: './nli-toolbar.component.html',
  styleUrls: ['./nli-toolbar.component.css']
})
export class NliToolbarComponent implements OnInit {
  @Input()
  showBackBtn = false;

  @Input()
  backBtnUrl: string;

  @Output()
  backBtnClick = new EventEmitter<any>();

  @Input()
  showMenuBtn = false;

  @Output()
  menuBtnClick = new EventEmitter<any>();

  userName = '--';
  clientName = '--';

  iconsBaseUrl = '/assets/img/icons/';
  icons = [
    { name: 'nli_account-outline', icon: 'account-outline.svg' },
    { name: 'nli_lock_outline', icon: 'lock-outline.svg' },
    { name: 'nli_autorenew', icon: 'autorenew.svg' },
    { name: 'nli_logout', icon: 'logout.svg' }
  ];

  constructor(
    private $sessionStorage: SessionStorageService,
    private router: Router,
    private authService: AuthenticationService,
    private clientService: ClientService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.icons.forEach(icon =>
      this.iconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(this.iconsBaseUrl + icon.icon)
      )
    );
  }

  ngOnInit() {
    this.authService.getCurrentUserName().subscribe(userName => {
      this.userName = userName;
    });
    this.clientName = this.clientService.getClientName();
  }

  onClickClient(): void {
    this.router.navigateByUrl('/clients');
  }

  onClickLogout(): void {
    this.authService.logout();
  }

  onClickPassword(): void {
    console.log('clicked password button');
  }

  onClickProfile(): void {
    console.log('clicked profile button');
  }

  onBackBtnClick(event: any) {
    this.backBtnClick.emit(event);
  }

  onMenuBtnClick(event: any) {
    this.menuBtnClick.emit(event);
  }
}
